import React from "react";
import { connect } from "react-redux";
import { Input, Select } from "../Input";
import { Button } from "../Button";
import language from "../../language";
import axios from "axios";
import toastMessage from "../../utils/toastMessage";
import { getStorage } from "../../utils/storage";
import {
// eslint-disable-next-line no-unused-vars
  fetchComponentsSeparation,
} from "../../utils/queries/production/components";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

const types = [
  {
    label: "NORMAL_WEIGHT",
    value: "NORMAL_WEIGHT",
  },
  {
    label: "NORMAL_WEIGHT_APHERESIS_PLATELET",
    value: "NORMAL_WEIGHT_APHERESIS_PLATELET",
  },
  {
    label: "LOW_WEIGHT",
    value: "LOW_WEIGHT",
  },
  {
    label: "UNDER_WEIGHT",
    value: "UNDER_WEIGHT",
  },
  {
    label: "OVER_WEIGHT",
    value: "OVER_WEIGHT",
  },
  {
    label: "LEAKAGE",
    value: "LEAKAGE",
  },
  {
    label: "LOW_PLATELET_COUNT",
    value: "LOW_PLATELET_COUNT",
  },
  {
    label: "AGGREGATED_PLATELET",
    value: "AGGREGATED_PLATELET",
  },
  {
    label: "PLATELET_WITH_RED_BLOOD_CELLS",
    value: "PLATELET_WITH_RED_BLOOD_CELLS",
  },
];

class NewStatus extends React.Component {
  state = {
    label: "",
    value: "",
    error: {},
    isSubmitting: false,
    min: "",
    max: "",
    statuses: [],
    description: "",
    code: "",
    components: [],
    component: null,
    status: null,
    type: null,
  };

  componentDidMount = async () => {
    this.getComponents(true);

    let statuses = [
      {
        label: "Received",
        value: "received",
      },
      {
        label: "Quarantined",
        value: "quarantined",
      },
      {
        label: "Reject",
        value: "rejected",
      },
    ];

    this.setState({ statuses, status: this.state.statuses[0] });

    if (this.props._id) {
      this.setState({
        ...this.props,
        status: this.props.status
          ? { label: this.props.status, value: this.props.status }
          : null,
        type: this.props.type
          ? {
              label: this.props.type,
              value: this.props.type,
            }
          : null,

        component: this.props.component
          ? this.props.component?.map((el) => {
              return {
                label: el.name + " " + el.code,
                value: el._id,
              };
            })
          : null,
      });
    }
  };

  getComponents = async (isLoadingComponent, search = {}) => {
    try {
      const { defaultLanguage } = this.props;

      this.setState({ isLoadingComponent });

      const data = await fetchComponentsSeparation(defaultLanguage, {
        inputType: "dropdown",
        type: "separation",
        ...search,
      });

      this.setState({
        data: data,
        isLoadingComponent: false,
        components: data,
      });

      return data;
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  onChangeText = async (field, e) => {
    let { error } = this.state;
    let inputValue = e && e?.target ? e?.target?.value : e;

    delete error[field];

    await this.setState({
      [field]: inputValue,
      error,
    });
  };

  validateForm() {
// eslint-disable-next-line no-unused-vars
    let { value, label, min, max, error, type, component, priority } =
// eslint-disable-next-line no-unused-vars
      this.state;

    if (!component) {
      error.component = language[this.props.defaultLanguage].component_required;
    }

    if (value === "") {
      error.value = language[this.props.defaultLanguage].value_required;
    }

    if (label === "") {
      error.label = language[this.props.defaultLanguage].label_required;
    }

    if (min === "") {
      error.min = language[this.props.defaultLanguage].min_required;
    }

    if (max === "") {
      error.max = language[this.props.defaultLanguage].max_required;
    }

    if (!type) {
      error.type = language[this.props.defaultLanguage].type_required;
    }

    this.setState({ error });
  }

  onSubmit = async () => {
    await this.validateForm();

    if (Object.keys(this.state.error).length === 0) {
      this.setState({
        isSubmitting: true,
      });

      let { min, max, label, value, status, description, type, component } =
          this.state,
        url = `${API_URL}/bagStatus`,
        { _id } = this.props,
        method = "POST",
        user = await getStorage();

      let requestedBody = {
        value,
        label,
        min,
        max,
        status: status.value,
        description,
        type: type.value,
        component: Array.isArray(component)
          ? component.map((el) => el.value)
          : component.value,
      };

      if (_id && _id !== "") {
        method = "PUT";
        requestedBody.id = _id;
      }

      const options = {
        method,
        url,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + user.token,
        },
        data: requestedBody,
      };

      axios(options)
        .then((data) => {
          this.setState({
            isSubmitting: false,
          });

          toastMessage(
            "success",
            language[this.props.defaultLanguage][
              method === "PUT" ? "update_data_success" : "add_data_success"
            ]
          );

          this.props.getData(true);
          this.props.handleCloseModal();
        })
        .catch((error) => {
          toastMessage("error", error);

          this.setState({ isSubmitting: false });
        });
    }
  };

  render() {
    return (
      <div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-12">
              <Input
                placeholder={
                  language[this.props.defaultLanguage].label_placeholder
                }
                label={language[this.props.defaultLanguage].label}
                required
                value={this.state.label}
                onChange={(e) => this.onChangeText("label", e)}
                error={this.state.error.label}
              />
            </div>
            <div className="col-md-12">
              <Input
                placeholder={
                  language[this.props.defaultLanguage].value_placeholder
                }
                label={language[this.props.defaultLanguage].value}
                required
                value={this.state.value}
                onChange={(e) => this.onChangeText("value", e)}
                error={this.state.error.value}
              />
            </div>
            <div className="col-md-12">
              <Select
                defaultOptions={this.state.components}
                loadOptions={(e) => this.getComponents(true, { q: e })}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].base_component}
                required
                value={this.state.component}
                onChange={(e) => this.onChangeText("component", e)}
                error={this.state.error.component}
                loading={this.state.isLoadingComponent}
                isMulti
              />
            </div>
            <div className="col-md-6">
              <Input
                placeholder={
                  language[this.props.defaultLanguage].min_placeholder
                }
                label={language[this.props.defaultLanguage].min}
                required
                value={this.state.min}
                onChange={(e) => this.onChangeText("min", e)}
                error={this.state.error.min}
                type="number"
              />
            </div>

            <div className="col-md-6">
              <Input
                placeholder={
                  language[this.props.defaultLanguage].max_placeholder
                }
                label={language[this.props.defaultLanguage].max}
                required
                value={this.state.max}
                onChange={(e) => this.onChangeText("max", e)}
                error={this.state.error.max}
                type="number"
              />
            </div>
            <div className="col-md-12">
              <Select
                options={types}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].type}
                required
                value={this.state.type}
                onChange={(e) => this.onChangeText("type", e)}
                error={this.state.error.type}
              />
            </div>
            <div className="col-md-12">
              <Select
                options={this.state.statuses}
                placeholder={language[this.props.defaultLanguage].select}
                label={language[this.props.defaultLanguage].status}
                required
                value={this.state.status}
                onChange={(e) => this.onChangeText("status", e)}
                error={this.state.error.status}
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            text={language[this.props.defaultLanguage].cancel}
            onPress={this.props.handleCloseModal}
            className="btn-default"
          />
          <Button
            text={language[this.props.defaultLanguage].submit}
            onPress={this.onSubmit.bind(this)}
            isSubmitting={this.state.isSubmitting}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(NewStatus);
